// extracted by mini-css-extract-plugin
export default {"cls1":"YM1Uuu3CWyZQd3sS_w59","cls2":"h6H6Lhf__M6VG3iHnCmz YM1Uuu3CWyZQd3sS_w59","isPhone":"qWkIi4Cz0ouV_EEeSH6Y","bookingAppRedesign":"KawRDMJsiwWUU1FVfyyW"};